import { render } from "./QuoteDetailsPage.vue?vue&type=template&id=74e65615&lang=html"
import script from "./QuoteDetailsPage.vue?vue&type=script&lang=js"
export * from "./QuoteDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__